import React, {useState, useContext, useEffect} from "react";
import {Flex} from "rebass";
import {useHistory, useParams} from "react-router-dom";

import {PatientsContext, AuthContext} from "../../Contexts";
import {Patient} from "../../Types";
import {PatientSelectSideBar} from "./PatientSelectSideBar";
import {PatientsOverview} from "./PatientsOverview";


export const Patients = () => {
  const [selectedPatient, setSelectedPatient] = useState<undefined | Patient>(undefined);

  const patientContext = useContext(PatientsContext);
  const authContext = useContext(AuthContext);

  const history = useHistory();

  const {id} = useParams<{id?: string}>();

  useEffect(() => patientContext.passHistory(history))

  useEffect(() => {
    const effect = async () => {
      if (id && !patientContext.loading) {
        const patient = patientContext.patients.find((p) => p.clinic_user_id === id) || null;
        if (patient) {
          setSelectedPatient(patient);
        }
      }
    };
    effect();

    const path = history.location.pathname.split('/')
    if (path[2] === undefined || path[2] === "") {
      const firstPatient = patientContext.patients.find(patient => patient.is_active === "1")
      // if (firstPatient) history.push(`/patient/${firstPatient?.clinic_user_id}/configuration`);
    }

  }, [id, patientContext.loading, patientContext.patients, authContext.user]);

  return (
    <>
      <Flex>
        <PatientSelectSideBar selectedPatient={selectedPatient}/>
        <PatientsOverview patient={selectedPatient}/>
      </Flex>
    </>
  );
};

